import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Text,
} from '@chakra-ui/react';

const NotEnoughWinnersModal = ({ isOpen, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Invalid Prize Distribution</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text fontSize="lg" fontWeight="medium">
                        The number of winners is less than the number of prizes. Please regenerate winners.
                    </Text>
                </ModalBody>

            </ModalContent>
        </Modal>
    );
};

export default NotEnoughWinnersModal;
